<template>
  <EmdFormGroup
    :label="$t('trading-name')"
    required
    :state="getState($v.recipient.trading_name)"
    :feedbacks="feedbacks($v.recipient.trading_name)"
  >
    <EmdInput
      @input="() => $v.recipient.trading_name.$touch()"
      v-model="recipient.trading_name"
      name="trading_name"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { corporationUser } from '../validations'
export default {
  name: 'TradingNameInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    trading_name: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: corporationUser }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "trading-name": "Razão Social"
      },
    "en-US": {
      "trading-name": "Trading Name"
    }
  }
</i18n>
